/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { Tooltip } from 'antd'
import colors from '@sportninja/common/constants/appColors'
import Icon from 'src/components/Icon'
import NotificationSettingsGearIcon from 'src/components/icons/NotificationSettingsGearIcon'

interface ProfileActionButtonsProps {
  onEditClick: () => void
  onSettingsClick: () => void
}

const buttonStyle = css`
  background: transparent;
  border: 1px solid ${colors.PRIMARY};
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(242, 180, 0, 0.1);
  }
`

const ProfileActionButtons: React.FC<ProfileActionButtonsProps> = ({
  onEditClick,
  onSettingsClick,
}) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 16px;
        flex-shrink: 0;
      `}
    >
      <Tooltip title='Edit Profile' mouseEnterDelay={1} placement='bottom'>
        <button type='button' onClick={onEditClick} css={buttonStyle}>
          <Icon name='pencil' fontSize={18} color={colors.PRIMARY} />
        </button>
      </Tooltip>
      <Tooltip
        title='Notification Settings'
        mouseEnterDelay={1}
        placement='bottom'
      >
        <button type='button' onClick={onSettingsClick} css={buttonStyle}>
          <NotificationSettingsGearIcon size={18} color={colors.PRIMARY} />
        </button>
      </Tooltip>
    </div>
  )
}

export default ProfileActionButtons
